import React, { useCallback, useState, useEffect, useMemo } from 'react'
import { IcoMoon, VehicleNotFitIcon, PowersportNotFitIcon } from '@usap/uicomponents'
import { OverlaySpinner } from '@usap/widgets'
import VehicleSelectorWmo from '../../../../../../vsComponent/VehicleSelectorWmo'
import useUpdateVehicle from '../hooks/useUpdateVehicle'
import { toVehicleContext } from '../../../../../../DIFM/models/DifmVehicle'

import {
  StyledFitmentCTA,
  StyledFitmentInfoContainer,
  StyledDoesNotFit,
  StyledIconContainer,
  StyledFitmentVehicle,
  StyledDoesNotFitWrapper,
} from '../VehicleFitmentWmo.css'

const spinnerStyle = { left: 0, top: 0 }

const DoesNotFitWmo = ({
  product,
  vehicle,
  showSpinner,
  shouldShowSpinner,
  handleViewCorrectPart,
  correctPartCtaTestId,
  changeVehicleCtaTestId,
  isPowersport,
}) => {
  const [cartVehicleDB, setCartVehicleDB] = useState({})

  const updateVehicle = useUpdateVehicle({
    cartVehicleDB,
    product,
    shouldShowSpinner,
  })

  const handleChangeVehicle = useCallback(
    vehicleSelected => {
      const updatedVehicle = toVehicleContext(vehicleSelected)
      updatedVehicle.itemId = product?.productId
      setCartVehicleDB(updatedVehicle)
    },
    [product],
  )

  useEffect(() => {
    if (cartVehicleDB && cartVehicleDB?.year) {
      updateVehicle()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartVehicleDB])

  const icon = useMemo(() => {
    if (isPowersport) {
      return PowersportNotFitIcon
    }
    return VehicleNotFitIcon
  }, [isPowersport])

  return (
    <StyledDoesNotFitWrapper data-testid="does-not-fit">
      <OverlaySpinner active={showSpinner} style={spinnerStyle} centered />

      <StyledIconContainer>
        <IcoMoon
          icon={icon}
        />
      </StyledIconContainer>
      <StyledFitmentInfoContainer>
        <StyledDoesNotFit>
          Does Not Fit &nbsp;
        </StyledDoesNotFit>
        <StyledFitmentVehicle>
          {vehicle}
        </StyledFitmentVehicle>
        <div>
          <StyledFitmentCTA onClick={handleViewCorrectPart} data-testid={correctPartCtaTestId}>
            View Correct Part
          </StyledFitmentCTA>

          <VehicleSelectorWmo
            componentType="fitment"
            button={
              <StyledFitmentCTA
                data-testid={changeVehicleCtaTestId}
                style={{
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  color: "#282832",
                }}
              >
                Change Vehicle
              </StyledFitmentCTA>
            }
            onAddVehicle={handleChangeVehicle}
          />
        </div>
      </StyledFitmentInfoContainer>
    </StyledDoesNotFitWrapper>
  )
}

export default DoesNotFitWmo
